<template lang="html">
  <div class="game-object-properties float-panel sidemenu-object" @drop="dropScript" @dragover.prevent @dragenter.prevent>
		<button type="button" onclick="document.body.classList.remove('show-sidemenu-object')" style="border: none;margin-right: 5px;display: block;float: right;">X</button>
		<label class="title" style="display: block;padding: 10px;">Object Properties</label>
		<div v-if="gameObject">
			<div class="script-properties">
				<input type="text" v-model="gameObject.name" placeholder="Name" />
			</div>
			<TransformProperties v-model="gameObject.transform" @change="updateRender()"/>
			<AnimatorProperties v-model="gameObject.animator" :assets="animatorAssets" :spritesheets="animatorSpritesheets" @change="updateRender()"/>
      <ColliderProperties v-if="gameObject.collider" v-model="gameObject.collider" @change="updateRender()" @remove="gameObject.collider = null;renderGameObjectProperties();updateRender()" />
			<LightProperties v-if="gameObject.light" v-model="gameObject.light" @change="updateRender()" @remove="gameObject.light = null;renderGameObjectProperties();updateRender()" />
      <ScriptProperties v-for="(scriptRef, index) in gameObject.scripts" :key="scriptRef.id" :scriptRef="scriptRef" @delete="gameObject.scripts.splice(index, 1);renderGameObjectProperties();" />
		</div>
		<div class="extra"></div>
	</div>
</template>

<script>
import TransformProperties from '@/assets/components/stage/TransformProperties.vue'
import AnimatorProperties from '@/assets/components/stage/AnimatorProperties.vue'
import ColliderProperties from '@/assets/components/stage/ColliderProperties.vue'
import LightProperties from '@/assets/components/stage/LightProperties.vue'
import ScriptProperties from '@/assets/components/stage/ScriptProperties.vue'
import GameStudio from '@/assets/js/GameStudio.js'
import { List, Collapsible } from '@/assets/old/components/script.js'
const Util = window.Util;

export default {
  props: ['gameObject'],
  components: {
    TransformProperties,
    AnimatorProperties,
    ColliderProperties,
    LightProperties,
    ScriptProperties
  },
  data() {
    return {
  		animatorAssets: GameStudio.getFilesWithExtensions(['.png', '.jpg']),
  		animatorSpritesheets: GameStudio.getFilesWithExtensions(['.spritesheet'])
  	};
  },
  computed: {
    addScriptItems() {
    	var items = [];
    	if (!this.gameObject.collider) {
    		items.push({name: '<i class="icon-now_widgets"></i> <span>Collider</span>', value: 'collider'});
    	}
    	if (!this.gameObject.light) {
    		items.push({name: '<i class="icon-lightbulb"></i> <span>Light</span>', value: 'light'});
    	}
      GameStudio.getFilesWithExtensions(['.js', '.blockly', '.ts']).filter(script => {
        return !this.gameObject.scripts.find(goScript => goScript.id === script.id);
      }).forEach(script => {
    		items.push({name: '<i class="icon-code"></i> <span>' + script.name + '</span>', value: script.id});
      });
      return items;
    }
  },
	methods: {
		updateRender() {
      this.$emit('render', null);
    },
		dropScript(event) {
			var allowed = ['x-gamefile/js', 'x-gamefile/ts', 'x-gamefile/blockly'];
			var file = event.dataTransfer.getData(event.dataTransfer.types.find(t => allowed.indexOf(t) !== -1));
			if (file) {
				file = JSON.parse(file);
				this.gameObject.scripts.push({
					id: file.id,
					data: []
				});
				this.renderGameObjectProperties();
				this.updateRender();
			}
			// Store.do('eventAddScript', id);
		},
    renderGameObjectProperties() {
      var self = this;
    	var gameObjectProperties = this.$el.querySelector('.game-object-properties .extra');
    	gameObjectProperties.innerHTML = '';
    	document.body.classList.remove('show-sidemenu-object');
    	if (!this.gameObject) return;
    	var gameObject = this.gameObject;
    	document.body.classList.add('show-sidemenu-object');
    	/*==========*/
    	var addScriptList = new List({
        items: this.addScriptItems,
        onselect: function (el, item) {
      		collapsible.node.classList.remove('active');
      		if (item.value === 'collider') {
      			gameObject.collider = {
      				x: 0,
      				y: 0,
      				width: 1,
      				height: 1
      			};
      		} else if (item.value === 'light') {
      			gameObject.light = {
      				type: 'Point',
      				position: {
      					x: 0.5,
      					y: 0.5
      				},
      				params: {
      					r1: 10,
      					r2: 100,
      					density: 0.8
      				}
      			};
      		} else {
      			gameObject.scripts.push({
      				id: item.value,
      				data: []
      			});
      		}
      		self.renderGameObjectProperties();
      		self.updateRender();
      	}
      });
    	var collapsible = new Collapsible({
    		btnHtml: '<button type="button" style="margin: 0;width: 100%;">Add script</button>',
    		innerNode: addScriptList.node,
    		innerStyle: {bottom: '18px'}
    	});
    	gameObjectProperties.appendChild(Util.nodefy('<div class="script-properties">')).appendChild(collapsible.node);
    }
  },
  watch: {
    gameObject() {
      this.renderGameObjectProperties();
    }
  },
  mounted() {
    this.renderGameObjectProperties();
  },
  beforeUnmount() {
    console.log('Destroy');
  }
}
</script>

<style lang="css" scoped>
</style>
